import { useQuery } from '@tanstack/react-query';
import PageLoader from 'Components/PageLoader';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { fetchCustomerTounch, fetchVendorTounch } from 'services/Tounches';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import VendorTouncheNew from './Vendor_tounche_new';
import CustomerTouncheNew from './CustomerTouncheNew';

const EditCustomerTounchNew = () => {
    const {id} = useParams()
    const allStates = useSelector((state) => state);
    const adminLoggedIn = allStates.reducer1;
    const clientCode = adminLoggedIn.ClientCode;
    const {
        data: CustomerTounch,
        isLoading,
        isError:customerTounchIsError,
        error:customerTounchError
      } = useQuery({
        queryKey: ["customerTounche/customerTounchById",id,clientCode],
        queryFn: fetchCustomerTounch,
        refetchOnWindowFocus: false,
        
      });
      useEffect(()=>{
        if(customerTounchIsError && customerTounchError){
          toast.error(customerTounchError?.message,{
            position:"top-center",
            duration:2000
          })
        }
      },[customerTounchIsError,customerTounchError])
      console.log(CustomerTounch)
  return (
    <div>
        {isLoading && <PageLoader/>}
        {!isLoading && !customerTounchIsError && (
        <CustomerTouncheNew editStatus={true} editData={CustomerTounch} editId={id}/>
        )}
    </div>
  )
}

export default EditCustomerTounchNew
